module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.spaces && _vm.spaces.length > 0) ? _c('div', [_c('v-alert', {
    staticClass: "py-0 px-2 ma-0",
    attrs: {
      "dismissible": "",
      "type": "warning",
      "value": true
    }
  }, [_vm._v("\n      These appointments span multiple spaces.\n      Please pick to which space you would like to assign this invoice to\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "px-2"
  }, [_c('v-subheader', {
    staticClass: "py-0 px-2 overline ma-0"
  }, [_vm._v("Choose a space")]), _vm._v(" "), _vm._l((_vm.spaces), function(space, index) {
    return _c('v-chip', {
      key: space.id,
      staticClass: "mt-0",
      attrs: {
        "outline": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedSpaceSettings = index
        }
      }
    }, [(index === _vm.selectedSpaceSettings) ? _c('v-icon', [_vm._v("check")]) : _vm._e(), _vm._v("\n          " + _vm._s(space.space_name || space.practice_name) + "\n      ")], 1)
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-system-bar', {
    staticClass: "overline"
  }, [_vm._v("Business settings")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "one-line": ""
    }
  }, [_c('v-list-tile', [(_vm.resizedLogoPicture) ? _c('v-list-tile-avatar', {
    attrs: {
      "tile": "",
      "small": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.resizedLogoPicture
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.settings && _vm.settings.practice_name) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.settings.practice_name)
    }
  }) : _c('span', [_vm._v("Business details")])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "small": "",
      "icon": "",
      "label": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.configureSettings.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.localExpanded === false) ? _c('v-btn', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "small": "",
      "icon": "",
      "label": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.localExpanded = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("expand_more")])], 1) : _c('v-btn', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "small": "",
      "icon": "",
      "label": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.localExpanded = false
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("expand_less")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.localExpanded) ? [_c('v-card-text', {
    on: {
      "click": _vm.configureSettings
    }
  }, [_c('strong', {
    staticClass: "overline"
  }, [_vm._v("Practice number:")]), _vm._v(" " + _vm._s(_vm.settings.practice_number) + "\n        "), _c('v-divider'), _vm._v(" "), _c('strong', {
    staticClass: "overline"
  }, [_vm._v("Billing address")]), _vm._v(":\n        "), (_vm.settings.billing_address) ? _c('pre', {
    staticClass: "caption",
    domProps: {
      "textContent": _vm._s(_vm.settings.billing_address)
    }
  }) : _c('div', [_vm._v("Add a billing address")]), _vm._v(" "), _c('strong', {
    staticClass: "overline"
  }, [_vm._v("Banking details")]), _vm._v(":\n        "), (_vm.settings.banking_details) ? _c('pre', {
    staticClass: "caption",
    domProps: {
      "textContent": _vm._s(_vm.settings.banking_details)
    }
  }) : _c('div', [_vm._v("Add banking details")])], 1), _vm._v(" "), (_vm.settings && _vm.requiredProgress < 100) ? _c('v-footer', {
    staticClass: "mt-0 pl-2 py-0 caption",
    attrs: {
      "small": "",
      "block": "",
      "tile": ""
    }
  }, [_c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "value": _vm.progressPercent,
      "color": _vm.progressColor,
      "rotate": -90,
      "width": "2",
      "size": 24
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.configureSettings.apply(null, arguments)
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": _vm.progressColor
    }
  }, [_vm._v(_vm._s(_vm.progressIcon))])], 1)], 1), _vm._v("\n        Configuration suggestions\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.configureSettings.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1) : _vm._e()] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc0f276a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/manage/InvoiceBillingDetails.vue
// module id = 1515
// module chunks = 9